<template>
  <div class='users is-margin-top'>
    <section>
      <div class='container'>

        <b-tabs v-model="active_tab" :animated='false'>

          <b-tab-item label="Список">
            <div class="columns is-margin-top">
              <div class="column is-two-thirds">  
                <div class="field has-addons">
                  <div class="control" style='width: calc(100% - 20px)'>
                    <b-input expanded placeholder="Поиск" type="search" icon="magnify" v-model='search_string'></b-input>
                  </div>
                  <div class='control'>
                    <button class='button' @click='search_string = ""'>X</button>
                  </div>
                </div>

                <b-table :data="table_data" :paginated='true' :pagination-simple='true' :striped='true' :narrowed='true' :loading='data_loading' :selected.sync='selected_user' default-sort='created' default-sort-direction='desc'>
                  <template slot-scope="props">
                    <b-table-column field="username" label="Имя пользователя" width="220" sortable>
                      {{ props.row.username }}
                    </b-table-column>
                    <b-table-column field="fio" label="ФИО" width="200" sortable>
                      {{ props.row.fio }}
                    </b-table-column>
                    <!-- <b-table-column field="document_number" label="Документ" width="140" sortable>
                      {{ props.row.document_number }}
                    </b-table-column>
                    <b-table-column field="birthday" label="Дата рождения" width="80" sortable>
                      <span v-if="props.row.birthday !== '' ">
                        {{ new Date(Date.parse(props.row.birthday)).toLocaleDateString() }}
                      </span>
                      <span v-else>
                      </span>
                    </b-table-column> -->
                    <b-table-column field="created" label="Дата регистрации" width="80" sortable numeric>
                        {{ new Date(props.row.created).toLocaleDateString() }}
                    </b-table-column>
                    <b-table-column field="phone" label="Телефон" width="140" sortable>
                      {{ props.row.phone }}
                    </b-table-column>
                    <!-- <b-table-column field="roles" label="Роли"  sortable>
                      <span class="tag" v-for='role in props.row.roles'>
                        {{ role }}
                      </span>
                    </b-table-column> -->
                    <b-table-column field="birthday" label="Д.Р." :custom-sort='birthday_sort' sortable>
                      {{ new Date(props.row.birthday).toLocaleDateString() }}
                    </b-table-column>
                    <b-table-column field="activated" label="Активирован" width="80" sortable boolean>
                      <b-checkbox disabled v-model='props.row.activated'></b-checkbox>
                    </b-table-column>
                  </template>
                </b-table>
              </div>
              <div class="column is-one-thirds">
                <!-- <a class="button" @click='fetch_data()'><span>Обновить список</span></a> -->
                <a class="button"><span>Найти по карте</span></a>
                <section class='is-margin-top box fast_edit'>

                  <div v-if='selected_user.hasOwnProperty("username")'>
                    <b-tabs :animated='false'>

                      <b-tab-item label="Аккаунт">

                        <b-field label="Имя пользователя" class='is-margin-top'>
                          <b-input placeholder='Имя пользователя' v-model='selected_user.username'></b-input>
                        </b-field>
                        <b-field label="Телефон">
                          <b-input placeholder='Телефон' v-model='selected_user.phone'></b-input>
                        </b-field>
                        <b-field label="Пароль">
                          <b-input type='password' placeholder='Пароль' v-model='change_password' password-reveal></b-input>
                        </b-field>
                        <b-field label="Подтверждение пароля">
                          <b-input type='password' placeholder='Подтверждение пароля' v-model='change_confirm' password-reveal></b-input>
                        </b-field>
                        <b-field label="Роли">
                          <n3-select v-model='selected_user.roles' multiple search>
                            <n3-option v-for='role in roles' :key='role' :value='role'>{{ role }}</n3-option>
                          </n3-select>
                        </b-field>
                        <b-field label="Дата регистрации">
                          {{ new Date(selected_user.created).toLocaleDateString() }}
                        </b-field>
                        <b-field label="Активирован">
                          <b-switch  v-model='selected_user.activated'></b-switch>
                        </b-field>
                        <a class='button is-primary' @click='fast_edit_save()'>Сохранить</a>
                        <!-- <a class='button'>Resend activation link</a> -->

                      </b-tab-item>

                      <b-tab-item label='ФИО'>
                        <photo v-model='selected_user.photo'></photo>
                        <b-field label="Ф.И.О." class='is-margin-top'>
                          <b-input placeholder='ФИО' v-model='selected_user.fio'></b-input>
                        </b-field>
                        <b-field label="Дата рождения" class='is-margin-top'>
                          <b-datepicker placeholder='Дата рождения' v-model='selected_user.birthday' :date-parser='date_parser'></b-datepicker>
                        </b-field>
                        <b-field label="Документ" class='is-margin-top'>
                          <b-input placeholder='Документ' v-model='selected_user.document_number'></b-input>
                        </b-field>

                        <b-field label="Учебное учереждение" class='is-margin-top'>
                          <b-input placeholder='Учебное учереждение' v-model='selected_user.school'></b-input>
                        </b-field>
                        <b-field label="Представитель" class='is-margin-top'>
                          <b-input placeholder='Представитель' v-model='selected_user.representive'></b-input>
                        </b-field>
                        <b-field label="Контакты представителя" class='is-margin-top'>
                          <b-input placeholder='Контакты представителя' v-model='selected_user.representive_contacts'></b-input>
                        </b-field>

                        <a class='button is-primary' @click='fast_edit_save()'>Сохранить</a>
                      </b-tab-item>

                      <b-tab-item label='Баланс'>
                        <blockquote>
                          <h4>Баланс: {{ selected_user.balance }}</h4>
                        </blockquote>
                        <button class='button is-light is-margin-top' style='margin-bottom: 10px;' @click='open_finance_history()'>История</button>
                        <div class="notification">
                          <b-field label='Сумма'>
                            <b-input v-model='finance_new.summ' type='text' placeholder='Сумма' icon='currency-rub'></b-input>
                          </b-field>
                          <b-field label='Операция'>
                              <b-select v-model='finance_new.action' placeholder='Операция'>
                                <option
                                  v-for='option in money_operation'
                                  :value = 'option.id'
                                  :key = 'option.id'>
                                  {{ option.label }}
                                </option>
                              </b-select>
                          </b-field>
                          <b-field label='Описание'>
                            <b-input v-model='finance_new.comments' type='text' placeholder='описание'></b-input>
                          </b-field>
                          <button class='button is-primary' @click='finance_execute()' :disabled='!finance_new_ready'>Применить</button>
                        </div>
                      </b-tab-item>

                      <b-tab-item label='Информация'>

                        <div class="card">
                          <header class="card-header">
                            <p class="card-header-title">
                              Карта
                            </p>
                          </header>
                          <div class="card-content">
                            <div class="content">
                              <div v-if='selected_user.card_number === "0"' class="notification">
                                Карта не привязана
                              </div>
                              <div v-else  class="notification">
                                Номер карты: {{ selected_user.card_number }}
                              </div>
                              <button class='button' @click='is_waiting_for_card=true;reader_target=selected_user'>Привязать карту</button>
                            </div>
                          </div>
                        </div>

                        <div class="card is-margin-top">
                          <header class="card-header">
                            <p class="card-header-title">
                              Прогресс
                            </p>
                          </header>
                          <div class="card-content">

                            <div class='notification' v-if='selected_user.got_pdd === true'>
                              Тест на права пройден!
                              <button class='button is-margin-top' @click='take_pdd'>Лишить прав</button>
                            </div>

                            <div class='notification' v-if='selected_user.got_pdd === false'>
                              Тест на права <b>не</b> пройден
                              <button class='button is-margin-top' @click='give_pdd'>Выдать права</button>
                            </div>

                            <button class='button' @click='show_progress=true'>Показать прогресс</button>

                          </div>
                        </div>

                        <b-modal :active.sync="show_progress" :width="640" scroll="keep">
                          <div class="card is-margin-top">
                            <header class="card-header">
                              <p class="card-header-title">
                                Пройденные тесты:
                              </p>
                            </header>
                            <div class="card-content">
                              <b-table :data='user_progress' stripped paginated sortable>
                                <template slot-scope="props">
                                  <b-table-column field="name" label="Название" sortable>
                                    {{ props.row.name }}
                                  </b-table-column>
                                </template>
                              </b-table>
                            </div>
                          </div>
                        </b-modal>

                        <div class='is-margin-top'>
                          <a class='button is-primary' @click='fast_edit_save()'>Сохранить</a>
                        </div>

                      </b-tab-item>

                    </b-tabs>
                  </div>
                  <div v-else class='is-margin-top notification'>
                    Выберите пользователя для быстрого редактирования.
                  </div>

                </section>
              </div>
            </div>
          </b-tab-item>
          
          <b-tab-item label="Добавить">
            <div class="columns is-variable is-3">
              <div class='column is-one-third'>
                <div class='box'>
                  <b-field label="Имя пользователя" class='is-margin-top'>
                    <b-input placeholder='Имя пользователя' v-model='new_user.username'></b-input>
                  </b-field>
                  <b-field label="Телефон">
                    <b-input placeholder='Телефон' v-model='new_user.phone'></b-input>
                  </b-field>
                  <b-field label="Пароль">
                    <b-input type='password' placeholder='Пароль' v-model='new_user.password' password-reveal></b-input>
                  </b-field>
                  <b-field label="Подтверждение пароля">
                    <b-input type='password' placeholder='Подтверждение пароля' v-model='new_user.confirm' password-reveal></b-input>
                  </b-field>
                  <b-field label="Роли">
                    <n3-select v-model='new_user.roles' multiple search>
                      <n3-option v-for='role in roles' :key='role' :value='role'>{{ role }}</n3-option>
                    </n3-select>
                  </b-field>
                  <b-field label="Активирован">
                    <b-switch  v-model='new_user.activated'></b-switch>
                  </b-field>
                  <a class='button is-primary' @click='add_user()'>Добавить пользователя</a>
                  <a class='button' @click='new_user_form_clear()'>Очистить форму</a>
                </div>
              </div>
              <div class='column is-one-third'>
                <div class='box'>
                  <photo v-model='new_user.photo'></photo>
                  <b-field label="Ф.И.О." class='is-margin-top'>
                    <b-input placeholder='ФИО' v-model='new_user.fio'></b-input>
                  </b-field>
                  <b-field label="Дата рождения" class='is-margin-top'>
                    <b-datepicker placeholder='Дата рождения' v-model='new_user.birthday'></b-datepicker>
                  </b-field>
                  <b-field label="Документ" class='is-margin-top'>
                    <b-input placeholder='Документ' v-model='new_user.document_number'></b-input>
                  </b-field>
                </div>
              </div>
              <div class='column is-one-third'>
                <div class='box'>
                  <div v-if='new_user.card_number === "0"' class="notification">
                    Карта не привязана
                  </div>
                  <div v-else  class="notification">
                    Номер карты: {{ new_user.card_number }}
                  </div>
                  <button class='button' @click='is_waiting_for_card=true;reader_target=new_user'>Привязать карту</button>
                  <b-field label="Учебное заведение" class='is-margin-top'>
                    <b-input placeholder='Учебное заведение' v-model='new_user.school'></b-input>
                  </b-field>
                  <b-field label="Представитель" class='is-margin-top'>
                    <b-input placeholder='Представитель' v-model='new_user.representive'></b-input>
                  </b-field>
                  <b-field label="Контакты представителя" class='is-margin-top'>
                    <b-input placeholder='Контакты представителя' v-model='new_user.representive_contacts'></b-input>
                  </b-field>
                </div>
              </div>
            </div>
          </b-tab-item>
          
         <!--  <b-tab-item label="Extended edit">
            <div class='is-margin-top'>
              Nothing to be edited yet :)
            </div>
          </b-tab-item> -->

        </b-tabs>

        <b-modal :active.sync="is_waiting_for_card" :width="320" scroll="keep">
          <div class='card'>
            <div class='card-content text-center'>
              <div class='is-margin-bottom'>
                <img src='static/images/icons8-foul-64.png' />
              </div>
              <div class='is-margin-bottom'>
                Приложите карту к считывателю
              </div>
            </div>
            <footer v-if='store.state.debug' class="card-footer">
               <a class='card-footer-item' @click='reader_read({ card_number: String(Math.floor(Math.random()*100000000000)) })'>Случайный номер</a>
               <a class='card-footer-item' @click='reader_read({ card_number: "80000000001" })'>Карта 1</a>
               <a class='card-footer-item' @click='reader_read({ card_number: "80000000002" })'>Карта 2</a>
               <a class='card-footer-item' @click='reader_read({ card_number: "80000000003" })'>Карта 3</a>
            </footer>
          </div>
        </b-modal>

      </div>
    </section>
  </div>
</template>

<script>
import FinanceLog from './FinanceLog.vue'
import { EventBus } from '../bus'
import photo from './Photo.vue'
import store from '../store'
// import webcam from 'vue-web-cam/src/webcam'

export default {
  name: 'Users',
  data: function () {
    this.$parent.active_tab = 'users'
    this.fetch_data()
    EventBus.$on('ws_on_message', this.ws_on_message)
    return {
      data_loading: true,
      active_tab: 0,
      users: [{username: '', phone: '', activated: true, created: 0}],
      selected_user: {},
      new_user: {username: '', phone: '', password: '', confirm: '', roles: ['client'], activated: false, fio: '', document_number: '', birthday: new Date(), card_number: '0', photo: {audio: {name: '', filename: '', filetype: '', filesize: 0}, image: {name: '', filename: '', filetype: '', filesize: 0}, video: {name: '', filename: '', filetype: '', filesize: 0}}, school: '', representive: '', representive_contacts: ''},
      change_password: '',
      change_confirm: '',
      roles: ['admin', 'manager', 'client', 'client_manager', 'police', 'garage'],
      money_operation: [{id: '+', label: 'Пополнение'}, {id: '-', label: 'Списание'}, {id: 'c', label: 'Коррекция'}],
      search_string: '',
      finance_history: [],
      finance_new: {summ: '', action: '', comments: ''},
      is_waiting_for_card: false,
      reader_target: '',
      is_taking_photo: false,
      photo_target: {},
      test_names: {},
      show_progress: false,
      store: store
    }
  },
  components: {
    photo
  },
  methods: {
    fetch_data: function () {
      var t = this
      t.data_loading = true
      var form = JSON.stringify({method: 'admin_get_users', params: {}})
      window.$.post(window.gw + 'async_api/user', {data: form}, function (r) {
        var d = JSON.parse(r)
        if (d.result === 'ok') {
          d.params.users.forEach(function (user) {
            t.prepare_user(user)
          })
          t.users = d.params.users
          t.data_loading = false
          t.test_names = d.params.test_names
          if (t.test_names[0] !== undefined) delete t.test_names[0]
          // if (t.selected_user !== {}) {
          // }
        }
      })
      return
    },
    fast_edit_save: function () {
      var t = this
      if (t.change_password !== t.change_confirm) { t.$toast.open({message: 'passwords does not match'}); return }
      if (t.change_password.length > 0) {
        if (t.change_password.length < 5) { t.$toast.open({message: 'password too short'}); return }
        t.selected_user.password = t.change_password
      }
      var form = JSON.stringify({method: 'admin_update_user', params: { user: t.selected_user }})
      window.$.post(window.gw + 'api/user', {data: form}, function (r) {
        var d = JSON.parse(r)
        if (d.result === 'ok') {
          t.$toast.open({
            message: 'SAVED!',
            type: 'is-success'
          })
          if (t.change_password.length > 0) {
            delete t.selected_user.password
            t.change_password = ''
            t.change_confirm = ''
          }
          // t.fetch_data()
        } else {
          t.$toast.open({
            message: d.params.msg,
            type: 'is-danger'
          })
        }
      })
      return
    },
    add_user: function () {
      var t = this
      if (t.new_user.username.length < 5) { t.$toast.open({message: 'username too short'}); return }
      if (t.new_user.password.length < 5) { t.$toast.open({message: 'password required'}); return }
      if (t.new_user.password !== t.new_user.confirm) { t.$toast.open({message: 'passwords does not match'}); return }
      var form = JSON.stringify({method: 'admin_add_user', params: {user: t.new_user}})
      window.$.post(window.gw + 'api/user', {data: form}, function (r) {
        var d = JSON.parse(r)
        if (d.result === 'ok') {
          t.$toast.open({
            message: 'SAVED!',
            type: 'is-success'
          })
          t.new_user = {username: '', phone: '', password: '', confirm: '', roles: ['client'], activated: false, fio: '', document_number: '', birthday: new Date(), card_number: '0', photo: {audio: {name: '', filename: '', filetype: '', filesize: 0}, image: {name: '', filename: '', filetype: '', filesize: 0}, video: {name: '', filename: '', filetype: '', filesize: 0}}, school: '', representive: '', representive_contacts: ''}
          // t.fetch_data()
        } else {
          t.$toast.open({
            message: d.params.msg,
            type: 'is-danger'
          })
        }
      })
      return
    },
    new_user_form_clear: function () {
      this.new_user = {username: '', phone: '', password: '', confirm: '', roles: ['client'], activated: false, fio: '', document_number: '', birthday: new Date(), card_number: '0', photo: {audio: {name: '', filename: '', filetype: '', filesize: 0}, image: {name: '', filename: '', filetype: '', filesize: 0}, video: {name: '', filename: '', filetype: '', filesize: 0}}, school: '', representive: '', representive_contacts: ''}
      return
    },
    finance_execute: function () {
      var _this = this
      var form = JSON.stringify({method: 'admin_edit_user_finance', params: {username: _this.selected_user.username, summ: _this.finance_new.summ, action: _this.finance_new.action, comments: _this.finance_new.comments}})
      window.$.post(window.gw + 'api/finance', {data: form}, function (r) {
        var d = JSON.parse(r)
        if (d.result === 'ok') {
          _this.$toast.open({
            message: 'Готово!',
            type: 'is-success'
          })
          // _this.fetch_data()
          // var action = _this.finance_new.action
          // if (action === '+') _this.selected_user.balance += Number(_this.finance_new.summ)
          // if (action === '-') _this.selected_user.balance -= Number(_this.finance_new.summ)
          // if (action === 'c') _this.selected_user.balance += Number(_this.finance_new.summ)
          _this.finance_new.summ = ''
          _this.finance_new.action = ''
          _this.finance_new.comments = ''
        } else {
          _this.$toast.open({
            message: d.params.msg,
            type: 'is-danger'
          })
        }
      })
    },
    open_finance_history: function () {
      this.$modal.open({parent: this, component: FinanceLog, hasModalCard: true, formProps: {'username': this.selected_user.username}})
    },
    ws_on_message: function (message) {
      message = JSON.parse(message)
      var method = message.method
      var params = message.params
      if (method === 'reader_read') this.reader_read(params)
      if (method === 'update_user') this.ws_update_user(params)
      if (method === 'add_user') this.ws_add_user(params)
    },
    reader_read: function (params) {
      var cnumber = params.card_number
      this.reader_target.card_number = cnumber
      this.is_waiting_for_card = false
      console.log(cnumber)
    },
    shoot_photo: function (params) {
      this.photo_target.photo = this.$refs.webcam.capture()
      this.is_taking_photo = false
      console.log(this.new_user.photo)
    },
    date_parser: function (date) {
      console.log(date)
      var d = new Date(Date.parse(date))
      return d
    },
    give_pdd: function () {
      var _t = this
      var form = JSON.stringify({method: 'admin_give_pdd', params: { user: _t.selected_user }})
      window.$.post(window.gw + 'api/user', {data: form}, function (r) {
        var d = JSON.parse(r)
        if (d.result === 'ok') {
          _t.selected_user.balance += 20
          _t.selected_user.progress[store.state.pdd_oid] = 0
          _t.selected_user.got_pdd = true
        }
      })
    },
    take_pdd: function () {
      var _t = this
      var form = JSON.stringify({method: 'admin_take_pdd', params: { user: _t.selected_user }})
      window.$.post(window.gw + 'api/user', {data: form}, function (r) {
        var d = JSON.parse(r)
        if (d.result === 'ok') {
          // _t.selected_user.progress[store.state.pdd_oid] = undefined
          delete _t.selected_user.progress[store.state.pdd_oid]
          _t.selected_user.got_pdd = false
        }
      })
    },
    ws_update_user: function (params) {
      var updated = params.user
      this.prepare_user(updated)
      this.users.forEach(function (user) {
        if (user._id.$oid === updated._id.$oid) {
          for (var key in updated) {
            user[key] = updated[key]
          }
        }
      })
    },
    ws_add_user: function (params) {
      this.users.push(params.user)
    },
    prepare_user: function (user) {
      if (user.birthday !== undefined) {
        if (user.birthday !== '') user.birthday = new Date(Date.parse(user.birthday))
        else user.birthday = new Date('1-1-1911')
      }
      if (user.progress !== undefined) {
        if (user.progress[store.state.pdd_oid] !== undefined) {
          user.got_pdd = true
        } else {
          user.got_pdd = false
        }
      }
    },
    birthday_sort: function (a, b, isAsc) {
      var q = new Date(a.birthday)
      var w = new Date(b.birthday)
      var now = new Date()
      var dnow = new Date(0, now.getMonth(), now.getDate())
      var d1 = new Date(0, q.getMonth(), q.getDate())
      var d2 = new Date(0, w.getMonth(), w.getDate())
      if (d1 < dnow) d1 = new Date(9999, 0, 0)
      if (d2 < dnow) d2 = new Date(9999, 0, 0)
      return Math.abs(d1 - dnow) - Math.abs(d2 - dnow)
    }
  },
  computed: {
    table_data: function () {
      var _this = this
      if (this.search_string.length < 3) return this.users
      return this.users.filter(function (user) {
        if (user.username !== undefined) {
          if (user.username.toUpperCase().indexOf(_this.search_string.toUpperCase()) >= 0) return true
        }
        if (user.phone !== undefined) {
          if (user.phone.toUpperCase().indexOf(_this.search_string.toUpperCase()) >= 0) return true
        }
        if (user.fio !== undefined) {
          if (user.fio.toUpperCase().indexOf(_this.search_string.toUpperCase()) >= 0) return true
        }
        if (user.document_number !== undefined) {
          if (user.document_number.toUpperCase().indexOf(_this.search_string.toUpperCase()) >= 0) return true
        }
        if (user.card_number !== undefined) {
          if (user.card_number.toString().toUpperCase().indexOf(_this.search_string.toUpperCase()) >= 0) return true
        }
        return false
      })
    },
    finance_new_ready: function () {
      if ((this.finance_new.summ >= 0) && (this.finance_new.action !== '')) return true
      return false
    },
    got_pdd: function () {
      if (this.selected_user === {}) return false
      var p = false
      if (this.selected_user.progress[store.state.pdd_oid] !== undefined) p = true
      return p
    },
    user_progress: function () {
      if (this.selected_user === {}) return false
      var p = []
      for (var i in this.selected_user.progress) {
        p.push({_id: i, name: this.test_names[i], last: this.selected_user.progress[i]})
      }
      return p
    }
  }
}
</script>

<style scoped>
.fast_edit {
  margin: 3px;
  margin-top: 10px;
  margin-left: 0px;
}
.checkbox {
  margin-top: 3px;
}
.tag {
  margin-left: 2px;
}
.columns {
  margin-top: 0;
}
.new_user_columns {
  margin-top: 20px;
  margin-left: 0px;
}
.webcam {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Users.vue